import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FileText, FileEdit, Briefcase, Target, Compass } from 'lucide-react';

const StatsGrid = ({ resumes, coverLetters, savedJobs, careerPlansCount, assessments }) => {
  const navigate = useNavigate();

  const stats = [
    {
      label: 'Resumes',
      count: resumes.length,
      icon: FileText,
      color: 'sky',
      path: '/resumes',
      testId: 'stats-resumes'
    },
    {
      label: 'Cover Letters',
      count: coverLetters.length,
      icon: FileEdit,
      color: 'orange',
      path: '/cover-letters',
      testId: 'stats-cover-letters'
    },
    {
      label: 'Saved Jobs',
      count: savedJobs.length,
      icon: Briefcase,
      color: 'green',
      path: '/saved-jobs',
      testId: 'stats-saved-jobs'
    },
    {
      label: 'Career Plans',
      count: careerPlansCount || 0,
      icon: Target,
      color: 'purple',
      path: '/career-plan-hub',
      testId: 'stats-career-plans'
    },
    {
      label: 'Assessments',
      count: assessments.length,
      icon: Compass,
      color: 'pink',
      path: '/assessments',
      testId: 'stats-assessments'
    }
  ];

  return (
    <section 
      className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3 sm:gap-4 lg:gap-6 mb-8 sm:mb-12" 
      aria-label="Dashboard statistics"
    >
      {stats.map((stat) => {
        const Icon = stat.icon;
        return (
          <div
            key={stat.testId}
            className="p-4 sm:p-6 bg-white rounded-xl sm:rounded-2xl border border-gray-200 cursor-pointer hover:shadow-lg transition-shadow min-h-[88px]"
            onClick={() => navigate(stat.path)}
            data-testid={stat.testId}
          >
            <div className="flex items-center justify-between mb-1 sm:mb-2">
              <span className="text-xs sm:text-sm text-gray-600">{stat.label}</span>
              <Icon className={`w-4 h-4 sm:w-5 sm:h-5 text-${stat.color}-600`} />
            </div>
            <div className={`text-2xl sm:text-3xl font-bold text-${stat.color}-600`}>
              {stat.count}
            </div>
          </div>
        );
      })}
    </section>
  );
};

export default StatsGrid;
